import { memo } from 'react';

import { createPortal } from 'react-dom';
import { useLocation } from 'react-router';

import { type ModalName } from '@/modals-names';

import { ROUTE_PATHS } from '@/shared/config/router/types';

import { type ModalsRegistrationDict } from '../types';
import { ModalWrapper } from './ModalWrapper';

interface Props {
  modals: ModalsRegistrationDict;
}

export const Modals = memo<Props>(({ modals }) => {
  const modalNames = Object.keys(modals) as ModalName[];

  const { pathname } = useLocation();

  if (pathname === ROUTE_PATHS.DAYS_STREAK) return null;

  return createPortal(
    <>
      {modalNames.map((name) => {
        return <ModalWrapper key={name} name={name} Component={modals[name].Component} />;
      })}
    </>,
    document.body
  );
});
